import React from 'react';
import Profile from './components/Profile';
import Login from './components/Login';
import SignUp from './components/Signup';
import CreateQuote from './components/AddQuote';
import Home from './components/Home';
import Error from './components/404';
import { ProtectedRoutes } from './context/ProtectedRoutes';

export const routes = [
  { path: '/', element: <Home /> },
  {
    path: '/profile/:userId',
    element: (
      <ProtectedRoutes>
        <Profile />
      </ProtectedRoutes>
    ),
  },
  {
    path: '/addQuote/:userId',
    element: (
      <ProtectedRoutes>
        <CreateQuote />
      </ProtectedRoutes>
    ),
  },
  { path: '/login', element: <Login /> },
  { path: '/signup', element: <SignUp /> },
  { path: '*', element: <Error /> },
];
